// Dependencies

// Styles
require("slick-carousel/slick/slick.scss");
require("./visionneuse-1-1.scss");

// JavaScript
require("slick-carousel/slick/slick.min.js");
var $ = require("jquery");
var $slider = $('.visionneuse-1-1');

if (!$('body.preview').length) {

    $slider.each(function () {

        $(this).slick({
            arrows: false,
            centerMode: true,
            slidesToShow: 1,
            infinite: false,
            dots: true,
            variableWidth: true
        });

        // Enable click on slide as a way to change
        $(this).on('click', '.slick-slide', function (e) {
            e.stopPropagation();
            var index = $(this).data("slick-index");
            if ($(this).parents('.slick-slider').slick('slickCurrentSlide') !== index) {
                $(this).parents('.slick-slider').slick('slickGoTo', index);
            }
        });

    });

}


//////////////////
// WEBPACK FOOTER
// ./LeLab.DomaineForget.Web/src/modules/catalog/visionneuse-1/view-1/index.js
// module id = 240
// module chunks = 0